import logo from '../../assets/images/main_logo.png';

export const authenticationContent = {
    "logo": {
        "src": logo,
        "alt": "Lumi Ads Logo",
    },
    'signIn': {
        "title": "Welcome Back!",
        "login": {
            "signup_prompt": "New to Lumi Bureau?",
            "signup_button_text": "Sign Up"
        },
        'SignUpPrompt': {
            'title': 'New to Lumi Bureau?',
            'btn_text': 'Sign Up'
        },
        "leftPanel": {
            "title": "Lumi Bureau",
            "description": "An exclusive listing platform for bureaus and brokers.",
            "cta": {
                "text": "New to Lumi Bureau?",
                "button": {
                    "label": "Sign Up",
                    "action": "redirect_to_sign_up"
                }
            }
        }
    },
    'signUp': {
        'title': 'Create Account',
        'description': "List your business on Lumi. Let's start with a simple registration.",
        "leftPanel": {
            "title": "Sign Up on Lumi Bureau",
            "description": "An exclusive listing platform for bureaus and brokers.",
            "cta": {
                "text": "Already have an account?",
                "button": {
                    "label": "Sign In",
                    "action": "redirect_to_sign_in"
                }
            }
        }
    },
    "continue_button_text": "Continue",
    "helpSection": {
        "text": "Need help?",
        "links": [{
                "label": "Contact Us",
                "url": "URL_to_contact_us_page"
            },
            {
                "label": "Privacy & Terms",
                "url": "URL_to_privacy_and_terms_page"
            }
        ]
    },
    "image": {
        "src": "promo-image-url",
        "alt": "Promo image showcasing Lumi Ads features"
    }
}